<template>
    <div class="vue-map-wrapper">
        <div :id="mapId" ref="mapWrapper" class="map-wrapper"></div>
    </div>
</template>

<script>
import 'jsvectormap'
import 'jsvectormap/dist/maps/world-merc.js'
import ModalWrapper from "./ModalWrapper.vue";

export default {
    name: "MapWrapper",

    props: {
        focusRegions: {
            type: Array,
            default: () => [],
        },
        mobileFocusRegions: {
            type: Array,
            default: () => [],
        },
        activeCountryCode: {
            type: String,
            default: '',
        },
        domains: {
            type: Array,
            default: () => [],
        },
        extraActiveCountries: {
            type: Object|Array,
            default: () => {}
        },
        extraActiveCountriesCodes: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            map: '',
        }
    },

    computed: {
        mapId() {
            return _.uniqueId('map-');
        },

        computedRegions() {
            if (window.matchMedia('min-width: 768px').matches) {
                return this.mobileFocusRegions
            }

            return this.focusRegions
        },

        mappedRegions() {
            let mappedKeys = _.mapKeys(this.domains, (domain) => domain.country)
            let mappedRegions = _.forEach(mappedKeys,(item, key) => mappedKeys[key] = 1)
            let mappedExtraKeys = _.mapKeys(this.extraActiveCountriesCodes, (country) => country);
            let mappedExtraRegions = _.forEach(mappedExtraKeys, (item, key) => mappedExtraKeys[key] = 1);

            return {...mappedRegions, ...mappedExtraRegions};
        }
    },

    created() {
        this.extraCountriesForMapping = this.extraActiveCountries;
    },

    mounted() {
        this.createMap()
    },

    methods: {
        createMap() {
            this.map = new jsVectorMap({
                selector: `#${this.mapId}`,
                map: 'world_merc',
                zoomOnScroll: false,
                regionsSelectableOne: true,
                backgroundColor: '#1C2B4A',
                focusOn: {
                    regions: this.computedRegions
                },
                series: {
                    regions: [
                        {
                            values: this.mappedRegions,
                            scale: {1: '#2DE630'},
                            normalizeFunction: 'polynomial',
                        }
                    ],
                },
                regionStyle: {
                    initial: {
                        fill: '#49556E',
                        stroke: '#49556E',
                        "stroke-width": 0.35,
                        "stroke-opacity": 1
                    },
                },
                onRegionClick: (event, code) => this.handleRegionClicked(code),
                onLoaded: (map) => {
                    this.checkInitialCountry()

                    window.addEventListener('resize', _.debounce(() => {
                        map.updateSize()
                    }, 200))
                }
            })
        },

        getCustomWebsite(code) {
            if (code === 'PL') {
                return 'https://nexdrive.pl'
            }

            return ''
        },

        handleRegionClicked(code) {
            let extraRegion = _.find(this.extraActiveCountries, (country) => {
                return _.isEqual(country.code, code)
            });

            if (!_.isNil(extraRegion) && code !== 'IE') {
                this.$modal.show(ModalWrapper, {
                    props: {
                        isExtraCountry: true,
                        extraCountryName: extraRegion.name,
                        customWebsite: this.getCustomWebsite(code)
                    },
                    label: `${window.Drupal.t('Garage')} modal ${extraRegion.name}`
                })
                return;
            }

            if (code === 'IE') {
                code = 'GB';
            }

            let clickedDomain = _.find(this.domains, (domain) => {
                return _.isEqual(domain.country, code)
            })

            if (_.isNil(clickedDomain)) {
                return
            }

            this.$modal.show(ModalWrapper, {
                props: {
                    item: clickedDomain,
                },
                label: `${window.Drupal.t('Garage')} modal ${clickedDomain.name}`
            })
        },

        checkInitialCountry() {
            const activePath = document.querySelector(`.vue-map-wrapper .map-wrapper [data-code="${this.activeCountryCode}"]`)

            if (_.isNil(activePath) || activePath.getAttribute('fill') !== '#2DE630') {
                return
            }

            activePath.classList.add('current-country')
        }
    }
}
</script>